import React from 'react';
import styles from './style.module.css'
import Typography from '../Typography/Typography';

interface FlatButtonsProps {
  onLogin?: () => void;
  onSignup?: () => void;
  isMobile?: boolean;
  onMobileClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  children?: React.ReactNode;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean;
}

const FlatButtons: React.FC<FlatButtonsProps> = ({
  isMobile = false,
  onMobileClick,
  className,
  onLogin,
  onSignup,
  children,
  onClick,
  type = 'button',
  disabled = false
}) => {
  // If children are provided, render them as a clickable button
  if (children) {
    return (
      <button 
        className={className} 
        onClick={onClick}
        type={type}
        disabled={disabled}
      >
        {children}
      </button>
    );
  }

  // Default auth buttons behavior
  // Define handlers outside of blocks to comply with strict mode
  // const handleLogin = (event: React.MouseEvent<HTMLButtonElement>): void => {
  //   throw new Error('Function not implemented.');
  // };

  // const handleSignup = (event: React.MouseEvent<HTMLButtonElement>): void => {
  //   throw new Error('Function not implemented.');
  // };

  if (isMobile) {
    return (
      <div className={styles.mobileAuth}>
        <button className={styles.mobileLoginBtn} onClick={onLogin}>
          Login
        </button>
        <button className={styles.mobileSignupBtn} onClick={onSignup}>
          Sign up
        </button>
      </div>
    );
  }

  // Desktop auth buttons
  return (
    <div className={styles.desktopAuth}>
      <button className={styles.loginBtn} onClick={onLogin}>
        <Typography
          variant="buttonText"
          fontFamily="satoshi"
          weight="bold"
          size="base"
          className={styles.loginText}>
          Login
        </Typography>
      </button>
      <button className={styles.signupBtn} onClick={onSignup}>
        <Typography
          variant="buttonText"
          fontFamily="satoshi"
          weight="bold"
          size="base"
          className={styles.signupText}>
          Sign up
        </Typography>
      </button>
    </div>
  );
};

export default FlatButtons;